export const initialState = {
  app: {
    sideBarOpen: true,
    subLinkOpen: null
  },
};

export default initialState;
